/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PatchTransactionInfoRequestOmitted
 */
export interface PatchTransactionInfoRequestOmitted {
    /**
     * 
     * @type {string}
     * @memberof PatchTransactionInfoRequestOmitted
     */
    userName: string;
    /**
     * 
     * @type {string}
     * @memberof PatchTransactionInfoRequestOmitted
     */
    userPhoneNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchTransactionInfoRequestOmitted
     */
    userMlsId: string;
    /**
     * 
     * @type {string}
     * @memberof PatchTransactionInfoRequestOmitted
     */
    officeName: string | null;
}

/**
 * Check if a given object implements the PatchTransactionInfoRequestOmitted interface.
 */
export function instanceOfPatchTransactionInfoRequestOmitted(value: object): value is PatchTransactionInfoRequestOmitted {
    if (!('userName' in value) || value['userName'] === undefined) return false;
    if (!('userPhoneNumber' in value) || value['userPhoneNumber'] === undefined) return false;
    if (!('userMlsId' in value) || value['userMlsId'] === undefined) return false;
    if (!('officeName' in value) || value['officeName'] === undefined) return false;
    return true;
}

export function PatchTransactionInfoRequestOmittedFromJSON(json: any): PatchTransactionInfoRequestOmitted {
    return PatchTransactionInfoRequestOmittedFromJSONTyped(json, false);
}

export function PatchTransactionInfoRequestOmittedFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchTransactionInfoRequestOmitted {
    if (json == null) {
        return json;
    }
    return {
        
        'userName': json['userName'],
        'userPhoneNumber': json['userPhoneNumber'],
        'userMlsId': json['userMlsId'],
        'officeName': json['officeName'],
    };
}

export function PatchTransactionInfoRequestOmittedToJSON(json: any): PatchTransactionInfoRequestOmitted {
    return PatchTransactionInfoRequestOmittedToJSONTyped(json, false);
}

export function PatchTransactionInfoRequestOmittedToJSONTyped(value?: PatchTransactionInfoRequestOmitted | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userName': value['userName'],
        'userPhoneNumber': value['userPhoneNumber'],
        'userMlsId': value['userMlsId'],
        'officeName': value['officeName'],
    };
}

